(function(){
  const isMobile = window.matchMedia("(max-width: 768px)").matches;

  document.querySelectorAll('.cs-banner').forEach((ele) => {
    let swiAutoplay = Boolean(ele.getAttribute("data-swi_autoplay"));
    let swiTime = Number(ele.getAttribute("data-swi_time"));
    let bannerSwiper = new Swiper (ele.querySelector('.banner-swiper'), {
      slidesPerView: 1,
      autoplay: swiAutoplay ? {
        delay: swiTime * 1000,
        disableOnInteraction: false
      } : false
    })
  })
  
  document.querySelectorAll('.cs-shipping-swiper .shipping-swiper').forEach((swiper) => {
    let shippingSwiper = new Swiper (swiper, {
      slidesPerView: 'auto',
      spaceBetween: 20
    })
  })

  document.querySelectorAll('.cs-video').forEach((ele) => {
    let videoCon, video, btn;
    if(!isMobile){
      videoCon = ele.querySelector(".cs-video-container .video-con");
    }else{
      videoCon = ele.querySelector(".cs-video-container .video-con-mb");
    }
    video = videoCon?.querySelector("video");
    if(!video) return;

    video.controls = false;
    video.addEventListener("play", function () {
      this.controls = true;
      this.parentElement.classList.add("play");
    });
    video.addEventListener("pause", function () {
      this.controls = false;
      this.parentElement.classList.remove("play");
    });
    video.addEventListener("ended", function () {
      this.controls = false;
      this.parentElement.classList.remove("play");
      this.currentTime = 0;
    });
    btn = videoCon.querySelector(".video-play-btn");
    if(!isMobile){
      let cursor = btn.querySelector("span");
      btn.addEventListener("click", function () {
        if(video.paused) video.play();
      });
      btn.addEventListener('mouseenter', function(){
        cursor.style.opacity = 1;
      })
      btn.addEventListener('mouseleave', function(){
        cursor.style.opacity = 0;
      })
      btn.addEventListener('mousemove', function(e){
        let rect = video.getBoundingClientRect();
        let scaleX = video.offsetWidth / rect.width;
        let scaleY = video.offsetHeight / rect.height;
        let offsetX = (e.clientX - rect.left) * scaleX;
        let offsetY = (e.clientY - rect.top) * scaleY;
        gsap.to(cursor, {
          x: offsetX,
          y: offsetY,
          ease: "power2.out",
          duration: 0.5
        });
      })
    }else{
      btn.querySelector("svg").addEventListener("click", function () {
        if(video.paused) video.play();
      });
    }
    let headCon = ele.querySelector(".cs-video-head");
    ScrollTrigger.create({
      id: 'cs-video',
      trigger: ele,
      start: () => "top top",
      end: () => "bottom-=500 bottom",
      scrub: 2,
      markers: false,
      animation: gsap.timeline()
        .fromTo(headCon, {y: 0, opacity: 1}, {y: -150, opacity: 0.5})
        .fromTo(headCon, {y: -150, opacity: 0.5}, {y: -300, opacity: 0}, ">")
        .fromTo(videoCon, {scale: 0.4}, {scale: 1}, "<")
    })
  })
  
  document.querySelectorAll('.cs-video-swiper').forEach((ele) => {
    let videoSwiper = new Swiper (ele.querySelector('.video-swiper-right.swiper'), {
      slidesPerView: 'auto',
      spaceBetween: 20,
      centeredSlides: isMobile,
      preventInteractionOnTransition: true,
      touchRatio: 1,
      threshold: 10,
      navigation: {
        nextEl: ele.querySelector('.swiper-button-next'),
        prevEl: ele.querySelector('.swiper-button-prev')
      },
      on: {
        'slideChange': function(){
          let videos = ele.querySelectorAll('.swiper-slide.video-item.play video');
          videos.forEach(video => video.pause())
        }
      }
    })
    ele.querySelectorAll("video").forEach((video) => {
      video.controls = false;
      video.addEventListener("play", function (e) {
        e.stopPropagation();
        this.controls = true;
        this.parentElement.classList.add("play");
      });
      video.addEventListener("pause", function (e) {
        e.stopPropagation();
        this.controls = false;
        this.parentElement.classList.remove("play");
      });
      video.addEventListener("ended", function (e) {
        e.stopPropagation();
        this.controls = false;
        this.parentElement.classList.remove("play");
        this.currentTime = 0;
      });
    });
    ele.querySelectorAll(".video-play-btn svg").forEach((btn) => {
      btn.addEventListener("click", function () {
        let video = this.parentElement.previousElementSibling;
        if(video) video.play();
      });
    });
  })

  document.querySelectorAll('.cs-blog-swiper').forEach((ele) => {
    let blogSwiper = new Swiper (ele.querySelector('.blog-swiper-container.swiper'), {
      slidesPerView: 'auto',
      spaceBetween: 20
    })
  })
  
  document.querySelectorAll('.cs-product-show .product-show-con').forEach((ele) => {
    if(!isMobile){
      let cursor = ele.querySelector('.learn-more-cursor');
      cursor.style.opacity = 0;
      ele.addEventListener('mouseenter', function(){
        cursor.style.opacity = 1;
      })
      ele.addEventListener('mousemove', function(e){
        let rect = ele.getBoundingClientRect();
        gsap.to(cursor, {
          x: e.clientX - rect.left,
          y: e.clientY - rect.top,
          rotate: -15,
          ease: "power2.out",
          duration: 0.5
        });
      })
      ele.addEventListener('mouseleave', function(){
        cursor.style.opacity = 0;
      })
    }else{
      let btn = ele.querySelector('.learn-more-btn');
      ele.addEventListener('click', function(e){
        e.preventDefault();
      })
      btn.addEventListener('click', function(){
        window.location.href = ele.href;
      })
    }
  })

  document.querySelectorAll('.cs-dynamic-gallery .dynamic-gallery-container').forEach((ele) => {
    ScrollTrigger.create({
      id: 'dynamic-gallery',
      trigger: ele,
      start: () => "top top+=75%",
      end: () => "bottom top+=25%",
      scrub: 1,
      markers: false,
      animation: gsap.timeline()
        .fromTo(ele.querySelectorAll('.dynamic-gallery-col.odd-col'), {y: "10%"}, {y: "0%"})
        .fromTo(ele.querySelectorAll('.dynamic-gallery-col.even-col'), {y: "0%"}, {y: "10%"}, "<")
    })
  })

  document.querySelectorAll('.cs-brand-list .brand-list-container').forEach((ele) => {
    ele.style.setProperty('--ani-scroll-width', `-${ele.querySelector('.brand-list-scroll').offsetWidth}px`);
    window.addEventListener('resize', () => {
      ele.style.setProperty('--ani-scroll-width', `-${ele.querySelector('.brand-list-scroll').offsetWidth}px`);
    })
  })

  document.querySelectorAll('.cs-collapsible-panel').forEach(ele => {
    if(!isMobile){
      let imgList = ele.querySelectorAll('.collapsible-panel-left img');
      let itemList = ele.querySelectorAll('.collapsible-panel-right .collapsible-panel-item');
      if(imgList.length > 0 && itemList.length > 0){
        let criticalPoint = window.innerHeight / 2;
        let activeIndex = 0, timer = null;
        function updateActiveIndex() {
          let i;
          for(i = imgList.length - 1; i > 0; i--) {
            if(imgList[i].getBoundingClientRect().top < criticalPoint) break;
          }
          if(activeIndex != i){
            setActiveItem(i);
          }
        }
        function setActiveItem(active) {
          activeIndex = active;
          let timeline = gsap.timeline({ease: "power2.out", duration: 0.5});
          for(let i = 0; i < itemList.length; i++) {
            let svgDom = itemList[i].querySelector('.collapsible-panel-head svg');
            let bodyDom = itemList[i].querySelector('.collapsible-panel-body');
            if(i == active){
              let offsetHeight = bodyDom.querySelector('p').offsetHeight + 20;
              timeline.to(svgDom, {rotate: -90}, "<").to(bodyDom, {height: offsetHeight}, "<");
            }else{
              timeline.to(svgDom, {rotate: 90}, "<").to(bodyDom, {height: 0}, "<");
            }
          }
        }
        setActiveItem(0);
        let headerHeight = document.querySelector('.section-header').offsetHeight;
        ele.querySelectorAll('.collapsible-panel-right .collapsible-panel-head').forEach((head, index) => {
          head.addEventListener('click', function(){
            window.scrollTo({
              top: imgList[index].offsetTop - headerHeight,
              behavior: 'smooth'
            })
          })
        })
        window.addEventListener('scroll', function() {
          clearTimeout(timer);
          timer = setTimeout(() => {
            requestAnimationFrame(updateActiveIndex);
          }, 100);
        });
      }
    }else{
      let panelSwiper = new Swiper (ele.querySelector('.collapsible-panel-swiper'), {
        slidesPerView: 'auto',
        spaceBetween: 20,
        navigation: {
          nextEl: ele.querySelector('.swiper-button-next'),
          prevEl: ele.querySelector('.swiper-button-prev')
        }
      })
    }
  })

  document.querySelectorAll('.cs-app').forEach((ele) => {
    if(!isMobile){
      let parent = ele.parentElement;
      let head = ele.querySelector('.cs-app-head');
      let body = ele.querySelector('.cs-app-body');
      let bodyTop = body.getBoundingClientRect().top - ele.getBoundingClientRect().top;
      let bodyHeight = body.offsetHeight;
      let img_list = body.querySelectorAll('.app-body-center img');
      let prevCard = null, prevCardH3 = null, nextCard = body.querySelector('.app-card-item[data-position="0"]');
      let card_position = Number(ele.getAttribute("data-card_position")) || 0.3;

      window.addEventListener("load", function(){
        let timeline = gsap.timeline({paused:true})
          .fromTo(head, {opacity: 1, scale: 1}, {opacity: 0, scale: 0.5})
          .fromTo(body, {y: 0}, {y: -bodyTop}, "<")
          .fromTo(nextCard, {y: bodyHeight, opacity: 0}, {y: bodyHeight * card_position, opacity: 1}, ">")
        for(let i=1; i<img_list.length; i++){
          prevCard = nextCard;
          prevCardH3 = prevCard.querySelector('h3');
          nextCard = body.querySelector(`.app-card-item[data-position="${i}"]`);
          timeline.fromTo(img_list[i-1], {opacity: 1}, {opacity: 0}, ">")
            .fromTo(img_list[i], {opacity: 0}, {opacity: 1}, "<")
            .fromTo(prevCardH3, {height: prevCardH3.offsetHeight}, {height: 0, padding: 0}, "<")
            .fromTo(nextCard, {y: bodyHeight, opacity: 0}, {y: bodyHeight * card_position, opacity: 1}, "<")
        }
        prevCard = nextCard;
        prevCardH3 = prevCard.querySelector('h3');
        timeline.fromTo(prevCardH3, {height: prevCardH3.offsetHeight}, {height: 0, padding: 0}, ">")
        ScrollTrigger.create({
          id: 'cs-app',
          trigger: parent,
          start: () => "top top",
          end: () => "bottom bottom",
          scrub: 1,
          markers: false,
          animation: timeline
        })
      })
    }else{
      let appSwiper = new Swiper (ele.querySelector('.cs-app-swiper'), {
        slidesPerView: 'auto',
        spaceBetween: 20,
        pagination: {
          el: ele.querySelector('.swiper-pagination')
        }
      })
    }
  })

  window.addEventListener("load", function(){
    ScrollTrigger.refresh();
  })
})()